module.exports = __webpack_public_path__ + "img/gnu_gallery9.3b4140c0.jpg";